import { combineReducers } from 'redux';
import {
  chainReducers,
  INITIAL_API_STATE,
  createApiReducer,
} from 'services/api';
import {
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';

import { transformProject } from '../transformations';
import { ProjectsActionTypes } from './actions';

const fetchProjectsReducer = createApiReducer(
  [
    ProjectsActionTypes.FETCH_PROJECTS_START,
    ProjectsActionTypes.FETCH_PROJECTS_SUCCESS,
    ProjectsActionTypes.FETCH_PROJECTS_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformProject) }),
  (data) => data
);

const projectsChainedReducers = chainReducers(
  INITIAL_API_STATE,
  fetchProjectsReducer
);

const fetchSearchReducer = createFetchSearchReducer('projects');
const addSearchReducer = createAddSearchReducer('projects');
const updateSearchReducer = createUpdateSearchReducer('projects');
const deleteSearchReducer = createDeleteSearchReducer('projects');

const searchChainedReducers = chainReducers(
  INITIAL_API_STATE,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  projects: projectsChainedReducers,
  searches: searchChainedReducers,
});
